import { firebaseDb } from '../../config/firebaseConfig'

async function getMarketPlace(slug) {
  const snapShotQuery = await firebaseDb
    .collection('marketplace')
    .where('slug', '==', slug)
    .get()
  let data = {}
  snapShotQuery.forEach((doc) => (data = { ...doc.data() }))
  return data
}

async function getEcommerceExperiences(agencyId, agencyName) {
  const snapShotQuery = await firebaseDb
    .collection(`/agency/${agencyId}/experiences`)
    .where('category', '==', 'ECOMMERCE')
    .get()

  const data = []
  snapShotQuery.forEach((doc) =>
    data.push({ ...doc.data(), agencyKey: agencyId, agencyName }),
  )

  return data
}

function getEcommerceProducts(agencyId, experienceId, ecommerceId) {
  return firebaseDb.collection(
    `agency/${agencyId}/experiences/${experienceId}/ecommerce/${ecommerceId}/products`,
  )
}

function getEcommerceCategoryProducts(agencyId, experienceId, ecommerceId) {
  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/ecommerce/${ecommerceId}/categoryProducts`,
    )
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    })
}

function createInvoice(agencyId, experienceId, invoice) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/invoice`)
    .add(invoice)
    .then((res) => {
      const orderDoc = firebaseDb.doc(
        `agency/${agencyId}/experiences/${experienceId}/invoice/${res.id}`,
      )
      invoice.key = res.id

      orderDoc.update(invoice)

      return res.id
    })
}

function getInvoiceDetails(agencyId, experienceId, invoiceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/invoice`)
    .doc(invoiceId)
    .get()
    .then((doc) => {
      return doc.data()
    })
}

function updateInvoice(agencyId, experienceId, invoiceId, data) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/invoice`)
    .doc(invoiceId)
    .update(data)
}

async function addAgencyToMarketplace(marketplaceId, newAgency) {
  const marketplaceResponse = await firebaseDb
    .doc(`/marketplace/${marketplaceId}`)
    .get()
  const data = [...marketplaceResponse.data().agencies, newAgency]

  await firebaseDb
    .doc(`/marketplace/${marketplaceId}`)
    .update({ agencies: data })
}

export {
  getMarketPlace,
  getEcommerceExperiences,
  getEcommerceCategoryProducts,
  getEcommerceProducts,
  createInvoice,
  getInvoiceDetails,
  updateInvoice,
  addAgencyToMarketplace,
}
